<template>
  <div>
    <ticket
      :event-name="event.name"
      :event-image="event.image"
      :event-location="event.location"
      :event-date="event.date"
      :event-note="event.note"
      :event-show-qrcode="event.show_qrcode"
      ticket-type-name="Lote exemplo"
      ticket-type-value="2000"
      :ticket-number="1">
    </ticket>
  </div>
</template>

<script>
import Ticket from './Ticket'

export default {
  name: 'PrintExample',
  components: {
    Ticket
  },
  data () {
    return {
      event: null
    }
  },
  mounted () {
    const example = this.$session.flash
      .get('example')
    this.event = example
  },
  updated () {
    let t = setInterval(() => {
      if (document.readyState === 'complete') {
        setTimeout(function () {
          window.print()
        }, 100)
        setTimeout(function () {
          window.close()
        }, 150)
        clearInterval(t)
      }
    }, 500)
  }
}
</script>

